'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _dotstatsuiteVisions = require('@sis-cc/dotstatsuite-visions');
var _src = require('../../bridge-d3-react/src');
var charts = _interopRequireWildcard(_src);
var _series = require('./chartUtils/series');
var _series2 = _interopRequireDefault(_series);
var _AxisLegend = require('./legends/AxisLegend');
var _AxisLegend2 = _interopRequireDefault(_AxisLegend);
var _utils = require('./utils');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Chart = function Chart(_ref) {
  var options = _ref.options,
    series = _ref.series,
    type = _ref.type,
    width = _ref.width,
    getAxisOptions = _ref.getAxisOptions;
  var ChartClass = charts[type];
  return _react2.default.createElement('div', null, R.is(Number, width) && width < 370 ? null : _react2.default.createElement(_AxisLegend2.default, {
    axis: 'y',
    data: {
      series: series
    },
    type: type
  }), _react2.default.createElement(ChartClass, {
    data: series,
    options: options,
    getAxisOptions: getAxisOptions
  }));
};
var ChartWrapper = function ChartWrapper() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = R.over(R.lensPath(['base', 'height']), R.when(function (h) {
    return h < 0;
  }, R.always(300)))(props.options);
  if ((0, _utils.isChartNoData)(props)) {
    var height = R.path(['base', 'height'], options);
    var style = {
      height: height
    };
    return _react2.default.createElement('div', {
      style: style
    }, _react2.default.createElement(_dotstatsuiteVisions.NoData, {
      message: props.noData || 'No Data'
    }));
  }
  return _react2.default.createElement(Chart, (0, _extends3.default)({}, props, {
    options: options,
    series: (0, _series2.default)(props.data.series, props.type, options) // responsive rule only display highlighted data
  }));
};
exports.default = ChartWrapper;